<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref, toRaw } from 'vue';

import KRadioField from '@/components/fields/KRadioField.vue';
import KTextField from '@/components/fields/KTextField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

type MyFilterType = 'personal';
type CompanyFilterType = 'company';

export interface InitialData {
  title?: string | null;
  filterType?: MyFilterType | CompanyFilterType | null;
}

export interface ValidData {
  title: string;
  filterType: MyFilterType | CompanyFilterType;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const myFilterType: MyFilterType = 'personal';
const companyFilterType: CompanyFilterType = 'company';

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  emit('submit', event, toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.savingCurrentSearchDialogForm"
    data-testid="savingCurrentSearchDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KTextField
      v-model="formData.title"
      label="Title"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      autofocus
    />
    <v-radio-group
      v-model="formData.filterType"
      :class="$style.radioGroup"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      inline
    >
      <KRadioField label="My filter" :value="myFilterType" />
      <KRadioField label="Company filter" :value="companyFilterType" />
    </v-radio-group>
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.savingCurrentSearchDialogForm {
}
  .field {
  }
  .radioGroup {
    margin-bottom: 0.5rem;
  }
</style>
